import {Grid} from '@yandex-delivery/blocks'
import type {VerticalsWidgetProps as Props} from '@yandex-delivery/form'
import type {ReactElement} from 'react'
import {Controller, useFormContext} from 'react-hook-form'

import {VerticalItem} from './VerticalItem/VerticalItem'
import * as classes from './Verticals@desktop.classes'

export function VerticalsWidget({config}: Props): ReactElement {
  const {options} = config
  const {control} = useFormContext()

  return (
    <Grid xs={12} item>
      <div className={classes.wrapper.verticals}>
        <Controller
          control={control}
          name="verticals"
          render={({field}) => (
            <>
              {options.map((itemProps, i) => (
                <VerticalItem
                  key={i}
                  active={field.value === itemProps.value}
                  onClick={field.onChange}
                  tag={itemProps.value === 'walking_courier' ? 'New!' : undefined}
                  {...itemProps}
                />
              ))}
            </>
          )}
        />
      </div>
    </Grid>
  )
}
